package org.lennycodes.hldi.components
import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.CssStyle
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text
import org.lennycodes.hldi.constants.HLDITheme

// Animation style objects
val  FadeInAnimation = CssStyle {
}

val SlideUpAnimation =  CssStyle {

}

@Composable
fun AnimatedCounter(
    target: Int,
    label: String,
    modifier: Modifier = Modifier
) {
    var count by remember { mutableStateOf(0) }

    LaunchedEffect(target) {
        val steps = 50
        val increment = target / steps

        for (i in 0..steps) {
            count = (increment * i).coerceAtMost(target)
            delay(30)
        }
        count = target
    }

    Div(
        attrs =
            modifier
                .textAlign(TextAlign.Center)
                .toAttrs()

    ) {
        Div(
            attrs = {
                style {
                    fontSize(48.px)
                    fontWeight(700)
                    color(HLDITheme.Colors.primary)
                    fontFamily("Playfair Display", "serif")
                }
            }
        ) {
            Text("${count}+")
        }
        Div(
            attrs = {
                style {
                    fontSize(16.px)
                    color(HLDITheme.Colors.mediumGray)
                    marginTop(8.px)
                }
            }
        ) {
            Text(label)
        }
    }
}